import { RequestManager } from "./index";

const sandboxUrl = process.env.BIG_FLIP_BASE_SANDBOX_URL;

const request = new RequestManager(sandboxUrl);
export default request;
